import { render, staticRenderFns } from "./HighFrequencyCurrentData.vue?vue&type=template&id=2155ccc4&scoped=true"
import script from "./HighFrequencyCurrentData.vue?vue&type=script&lang=js"
export * from "./HighFrequencyCurrentData.vue?vue&type=script&lang=js"
import style0 from "./HighFrequencyCurrentData.vue?vue&type=style&index=0&id=2155ccc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2155ccc4",
  null
  
)

export default component.exports